import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import * as yup from "yup";
import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";
import { queryClient } from "../App";
import { API_URL } from "../consts";
import { useSnackbar } from "notistack";
import { Button, Stack, TextField } from "@mui/material";
import { useEffect } from "react";
import { uiStore } from "../uiStore";

type Inputs = {
  oldPsw: string;
  newPsw: string;
  newPsw2: string;
};
const schema = yup.object({
  oldPsw: yup.string().required(),
  newPsw: yup.string().min(8, "Deve essere almeno 8 caratteri").required(),
  newPsw2: yup
    .string()
    .min(8, "Deve essere almeno 8 caratteri")
    .oneOf([yup.ref("newPsw"), null], "Deve coincidere con Nuova Password")
    .required(),
});

export function CambiaPassword() {
  const { enqueueSnackbar } = useSnackbar();

  const setTitle = uiStore((state) => state.setTitle);
  useEffect(() => {
    setTitle("Cambio Password");
  }, [setTitle]);

  const { mutate } = useMutation(
    (data: Inputs) => {
      return axios.post(API_URL + "auth/cambiaPassword", data);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries();
        enqueueSnackbar("Password aggiornata", { variant: "success" });
      },
      onError: (error: AxiosError) => {
        queryClient.invalidateQueries();
        enqueueSnackbar(error?.response?.data?.message ?? "Si è verificato un errore!", {
          variant: "error",
        });
      },
    }
  );

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<Inputs>({
    mode: "onChange",
    resolver: yupResolver(schema),
  });
  const onSubmit = (data: Inputs) => {
    mutate(data);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Stack sx={{ maxWidth: "400px" }}>
        <Controller
          name="oldPsw"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <TextField
              {...field}
              type="password"
              variant="standard"
              label="Password attuale"
              autoComplete="current-password"
              error={Boolean(errors.oldPsw)}
              helperText={errors.oldPsw?.message ?? " "}
            />
          )}
        />

        <Controller
          name="newPsw"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <TextField
              {...field}
              type="password"
              variant="standard"
              label="Nuova password"
              autoComplete="new-password"
              error={Boolean(errors.newPsw)}
              helperText={errors.newPsw?.message ?? " "}
            />
          )}
        />
        <Controller
          name="newPsw2"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <TextField
              {...field}
              type="password"
              variant="standard"
              autoComplete="new-password"
              label="Ripeti nuova password"
              error={Boolean(errors.newPsw2)}
              helperText={errors.newPsw2?.message ?? " "}
            />
          )}
        />
      </Stack>
      <Button type="submit" variant="contained" sx={{ mt: 2 }}>
        Modifica password
      </Button>
    </form>
  );
}
